var exports = {
  "kL": "container__ugokHR",
  "F9": "embedded__7nPFsJ",
  "U1": "headerRow__HBmmjW",
  "lu": "expandable__SBa0xQ",
  "yZ": "collapsed__vA7wnN",
  "sz": "expanded__0S2-Dc",
  "$g": "revealActionOnHover__Pcoza-",
  "$Z": "emphasizedLeadingVisual__96Jtmp",
  "Cc": "fullWidthActionSlotOnNarrow__NxAKIK",
  "ZY": "trailing__mz7sxn",
  "Up": "fullRowActionSlotOnNarrow__35inkT",
  "E1": "chevronButton__4Pn7oS",
  "DD": "title__HTWu5I",
  "h_": "description__lyPF6Y",
  "pW": "leadingVisual__R5ILNo",
  "rf": "body___OH9MG",
  "jC": "padded__2KgjSv",
};

module.exports = exports;
